export const SITE_CHANGE_MESSAGE: string =
  'I understand that changing the site the license is assigned to will result in any users on the previous site losing their access.'
